import { apiRequest } from "@/network/apiClient";
import { useEffect, useState } from "react";
import { API_ENDPOINTS } from "../apiEndpoints";


export const useLeadJourneyDetails = ({leadID}) => {
    const [leadJourney, setLeadJourney] = useState(null);
    const [initialPayout, setInitialPayout] = useState()
    const [loading, setLoading] = useState(false);

    const fetchData = async () => {
        setLoading(true);
        try{
            const result = await apiRequest(`${import.meta.env.VITE_BASE_URL}/${API_ENDPOINTS.GET_LEADS.JOURNEY}?lead_id=${leadID}`, 'GET')
            if (result){
                setLeadJourney(result)
                setInitialPayout(result.payout)
            }else{
                console.error("Failed to fetch lead journey:", resultDetails.error);
            }
        }catch (error){
            console.error('Error fetching data: ', error)
        }finally{
            setLoading(false)
        }
    };

    useEffect(() => {
        if (!leadID) return;
        fetchData();
    }, [leadID])

    return {leadJourneyAPI: leadJourney, initialPayout, refetch: fetchData}
}